import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CommonEndpoints, NotificationEndpoints } from '@core/constants/endpoints.const';
import { DT_PARAMS } from '@core/constants/pagination.const';
import { UserType } from '@core/enums/type.enum';
import { DtParams, SearchResult } from '@models/base-type/base-type.model';
import {
  IModuleNotificationModel,
  INotificationModel,
} from '@models/notification/notification.model';
import { ApiResponse } from '@models/response.model';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(private httpClient: HttpClient) {}

  get = (dtparams: DtParams = DT_PARAMS) => {
    return this.httpClient.post<
      ApiResponse<SearchResult<Array<INotificationModel>>>
    >(NotificationEndpoints.Notifications, dtparams);
  };

  delete = (notificationId: string) => {
    return this.httpClient.post<ApiResponse<string>>(
      `${NotificationEndpoints.Notifications}${CommonEndpoints.Delete}/${notificationId}`, null
    );
  };

  read = (userId: string, notificationId?: string) => {
    return this.httpClient.get<ApiResponse<string>>(
      `${NotificationEndpoints.NotificationsRead}?notificationIds=${notificationId}&userId=${userId}`
    );
  };

  getNotificationCount = (userId: string) => {
    return this.httpClient.get<ApiResponse<number>>(
      `${NotificationEndpoints.NotificationsCount}?userId=${userId}`
    );
  };

  getModuleNotificationCount = (
    userType: UserType,
    userId: string,
    moduleName: string
  ) => {
    return this.httpClient.get<ApiResponse<Array<IModuleNotificationModel>>>(
      `${NotificationEndpoints.ModuleNotificationsCount}?usertype=${userType}&userId=${userId}&moduleName=${moduleName}`
    );
  };
}
